import App from './src/core/App';

export const wrapRootElement = ({ element }) => <App>{element}</App>;
